import React, {Component} from 'react';
import {Grid, Row, Col, ControlLabel, Checkbox} from "react-bootstrap";
import ReactNotify from 'react-notify';
import ObsadaListaForm from "./components/ObsadaListaForm";
import ObsadaService from "../ObsadaService";
import ObsadaListaTable from "./components/ObsadaListaTable";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopButtonAdd} from "../../../../../componentsTopsa/buttons/TopButtons";
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";
import ObsadaListaZamianaForm from "./components/ObsadaListaZamianaForm";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import moment from 'moment'
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import ScrollUtilities from "../../../../../utilities/ScrollUtilities";


export default class ObsadaListaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokazFormularz: false,
            duplikowanaObsada: null,
            obsadaDoZamiany: null,
            kolorRezerwacja: '#00152c',
            kolorSprzedany: '#001f05',
            kolorSkasowany: '#291801',
            filtrZamiany: {value: 'brak', label: 'Brak filtra'},
            filtryZamiany: [
                {value: 'brak', label: 'Brak filtra'},
                {value: 'wszystkie', label: 'Pokaż wszystkie zamiany'},
                {value: 'kierowca', label: 'Pokaż zamiany wybrane przez kierowców'},
                {value: 'operator', label: 'Pokaż zamiany wybrane przez operatorów'},
            ],

            rekordy: [],
            rekordyFilter: [],
            filtrOpoznienia: {value: 'brak', label: 'Brak filtra'},
            filtryOpoznienia: [
                {value: 'brak', label: 'Brak filtra'},
                {value: 'nierozpoczete', label: 'Pokaż opóźnione, ktore jeszcze się nie rozpoczęły'},
                {value: 'rozpoczete', label: 'Pokaż opóźnione, które już wystartowały'},
            ],
        };
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickOdwolaj = this.onClickOdwolaj.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
        this.onClickDuplikuj = this.onClickDuplikuj.bind(this);
        this.onClickZmienStatus = this.onClickZmienStatus.bind(this);
        this.onClickEdytujZasoby = this.onClickEdytujZasoby.bind(this);
        this.onClickZapiszZamiane = this.onClickZapiszZamiane.bind(this);
        this.onChangeFiltrujZamiany = this.onChangeFiltrujZamiany.bind(this);
    }

    componentDidMount() {
        this.pobierzKoloryStatusow()
        this.setState({
            rekordy: this.props.obsady,
            rekordyFilter: this.props.obsady,
            filtrZamiany: {value: 'brak', label: 'Brak filtra - wszystkie rekordy'}
        })
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            rekordy: nextprops.obsady,
            rekordyFilter: nextprops.obsady,
            filtrZamiany: {value: 'brak', label: 'Brak filtra - wszystkie rekordy'}
        })
    }

    pobierzKoloryStatusow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                if (arr.length > 0) {


                    if (Boolean(arr.find(p => p.pozycja == 'rezerwacja'))) {
                        if (Boolean((arr.find(p => p.pozycja == 'rezerwacja').wartosc))) {
                            this.setState({
                                kolorRezerwacja: arr.find(p => p.pozycja == 'rezerwacja').wartosc
                            })
                        }

                    }
                    if (Boolean(arr.find(p => p.pozycja == 'opłacony'))) {
                        if (Boolean((arr.find(p => p.pozycja == 'opłacony').wartosc))) {
                            this.setState({
                                kolorSprzedany: arr.find(p => p.pozycja == 'opłacony').wartosc
                            })
                        }

                    }
                    if (Boolean(arr.find(p => p.pozycja == 'skasowany'))) {
                        if (Boolean((arr.find(p => p.pozycja == 'skasowany').wartosc))) {
                            this.setState({
                                kolorSkasowany: arr.find(p => p.pozycja == 'skasowany').wartosc
                            })
                        }

                    }
                }

            }

        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, duplikowanaObsada: null, obsadaDoZamiany: null})
    }

    onClickEdytuj(obj, obsadaid) {
        ScrollUtilities.scrollToTop()
        ObsadaService.editObsada(obsadaid, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano wpis', "", 3000)
                this.props.handlePobierzObsade(obj, 'edycja');
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji wpisu', "", 3000)
            }
        }.bind(this))
    }

    onClickDuplikuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({
            duplikowanaObsada: obj,
            pokazFormularz: true,
        })
    }

    onClickEdytujZasoby(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({
            obsadaDoZamiany: obj,
            pokazFormularz: true
        })
    }

    onClickOdwolajPrzywrocBis(obj,czyOdwolac){
        if(czyOdwolac){
            ObsadaService.odwolajObsadeBis(obj.id_ob).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie odwołano bis', "", 3000)
                    this.props.handlePobierzObsade(obj, 'odwolajBis');
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas próby odwołania bisu', "", 3000)
                }
            }.bind(this))
        }
        else{
            ObsadaService.przywrocObsadeBis(obj.id_ob).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie przywrócono bis', "", 3000)
                    this.props.handlePobierzObsade(obj, 'przywrocBis');
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas próby przywrócenia bisu', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickZapiszZamiane(obj) {

        ObsadaService.edytujZasobyObsady(obj.idOb, obj).then(function (response) {
            if (response.status < 300) {

                this.refs.notificator.success('Pomyślnie edytowano zasoby obsady', "", 3000)
                this.props.handlePobierzObsade(response.data, 'zamiana', obj);
                this.setState({
                    obsadaDoZamiany: null,
                    pokazFormularz: false
                })
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji zasobów obsady', "", 3000)
            }
        }.bind(this))
    }

    onClickOdwolaj(obj) {
        if (window.confirm('Czy odwołać kurs: ' + obj.trasa + ' z kierowcą ' + obj.imie_naz + ' o godzinie: ' + obj.godz_1p)) {
            ObsadaService.odwolajObsade(obj.id_ob).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie odwołano kurs', "", 3000)
                    this.props.handlePobierzObsade(obj, 'odwolanie');
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas odwoływania kursu', "", 3000)
                }
            }.bind(this))

        }
    }

    onClickZapisz(obj) {
        if (Boolean(this.state.duplikowanaObsada)) {
            ObsadaService.addObsadaBis(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano wpis bisowy', "", 3000)
                    this.props.handlePobierzObsade(response.data, 'duplikacja', obj);
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania wpisu bisowego', "", 3000)
                }
            }.bind(this))
        }
        else {
            ObsadaService.addObsada(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano wpis', "", 3000)
                    this.props.handlePobierzObsade(response.data, 'dodanie', obj);
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania wpisu', "", 3000)
                }
            }.bind(this))
        }


        this.zamknijFormularz();
    }

    onClickZmienStatus(obj, val) {

        if (window.confirm('Czy chcesz zmienić status kursu na ' + (Boolean(val) ? 'zablokowany' : 'dostępny') + '?')) {
            if (val) {
                // zmiana na zablokowany - wartosc true

                ObsadaService.zablokujKurs(obj.id_ob).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie edytowano status', "", 3000)
                        this.props.handlePobierzObsade(obj, 'zablokuj');
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas edycji statusu', "", 3000)
                    }
                }.bind(this))
            }
            else {
                ObsadaService.odblokujKurs(obj.id_ob).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie edytowano status', "", 3000)
                        this.props.handlePobierzObsade(obj, 'odblokuj');
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas edycji statusu', "", 3000)
                    }
                }.bind(this))
            }


        }
    }

    onChangeFiltrujZamiany(e) {
        this.setState({filtrZamiany: e})
        this.filtrujZamianyIOpoznienie(e.value, this.state.filtrOpoznienia.value)
    }

    static czyKursOpozniony(kurs) {

        let czasObecny = moment().add(1, 'hour').toJSON().substr(0, 16).replace('T', ' ')
        let czasKursu = kurs.data + ' ' + DateAndTimeFormat.formatHHMM(kurs.godz_1p)

        return (!Boolean(kurs.start_kursu) && czasKursu < czasObecny)
    }

    static czyKursRozpoczetySpozniony(kurs) {
        if (kurs.start_kursu) {
            let startKursu = kurs.start_kursu.substr(0, 16).replace('T', ' ')
            let czasKursu = kurs.data + ' ' + DateAndTimeFormat.formatHHMM(kurs.godz_1p)
            return (czasKursu < startKursu)
        } else return false
    }

    onChangeOpoznienie(e) {
        this.setState({filtrOpoznienia: e})
        this.filtrujZamianyIOpoznienie(this.state.filtrZamiany.value, e.value)
    }


    filtrujZamianyIOpoznienie(zamiana = this.state.filtrZamiany, opoznienie = this.state.filtrOpoznienia) {

        // ZAMIANA BRAK

        if (zamiana === 'brak' && opoznienie === 'brak') {
            this.setState({rekordyFilter: this.state.rekordy})
        }
        else if (zamiana === 'brak' && opoznienie === 'nierozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => ObsadaListaContainer.czyKursOpozniony(i))
            })
        }
        else if (zamiana === 'brak' && opoznienie === 'rozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => ObsadaListaContainer.czyKursRozpoczetySpozniony(i))
            })
        }

        // ZAMIANA WSZYSCY

        else if (zamiana === 'wszystkie' && opoznienie === 'brak') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => Boolean(i.powod_zam))
            })
        }
        else if (zamiana === 'wszystkie' && opoznienie === 'nierozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => Boolean(i.powod_zam) && ObsadaListaContainer.czyKursOpozniony(i))
            })
        }
        else if (zamiana === 'wszystkie' && opoznienie === 'rozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => Boolean(i.powod_zam) && ObsadaListaContainer.czyKursRozpoczetySpozniony(i))
            })
        }

        // ZAMIANA KIEROWCA

        else if (zamiana === 'kierowca' && opoznienie === 'brak') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => (i.powod_zam === 'KIEROWCA'))
            })
        }
        else if (zamiana === 'kierowca' && opoznienie === 'nierozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => (i.powod_zam === 'KIEROWCA') && ObsadaListaContainer.czyKursOpozniony(i))
            })
        }
        else if (zamiana === 'kierowca' && opoznienie === 'rozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => (i.powod_zam === 'KIEROWCA') && ObsadaListaContainer.czyKursRozpoczetySpozniony(i))
            })
        }

        // ZAMIANA OPERATOR

        else if (zamiana === 'operator' && opoznienie === 'brak') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => (Boolean(i.powod_zam)) && (i.powod_zam !== 'KIEROWCA'))
            })
        }
        else if (zamiana === 'operator' && opoznienie === 'nierozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => (Boolean(i.powod_zam)) && (i.powod_zam !== 'KIEROWCA') && ObsadaListaContainer.czyKursOpozniony(i))
            })
        }
        else if (zamiana === 'operator' && opoznienie === 'rozpoczete') {
            this.setState({
                rekordyFilter: Array.from(this.state.rekordy).filter(i => (Boolean(i.powod_zam)) && (i.powod_zam !== 'KIEROWCA') && ObsadaListaContainer.czyKursRozpoczetySpozniony(i))
            })
        }
    }


    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <div>
                    <Row>
                        <Col xs={12} style={{marginBottom:'5px'}}>
                            <div className={'pull-left'}>
                                <div>
                                    <ControlLabel>Filtr zamian kierowców</ControlLabel>
                                    <div style={{width: '340px'}}>
                                        <TopSelect onChange={this.onChangeFiltrujZamiany} value={this.state.filtrZamiany}
                                                   options={this.state.filtryZamiany} clearable={false}/>
                                    </div>
                                </div>
                            </div>
                            <div className={'pull-left'}>
                                <div style={{marginLeft: '30px'}}>
                                    <ControlLabel>Filtr opóźnienia</ControlLabel>
                                    <div style={{width: '370px'}}>
                                        <TopSelect onChange={(e) => this.onChangeOpoznienie(e)} value={this.state.filtrOpoznienia}
                                                   options={this.state.filtryOpoznienia} clearable={false}/>
                                    </div>
                                </div>
                            </div>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <div className={'pull-right'}>
                                    <TopButtonAdd onClick={() => {
                                        this.setState({pokazFormularz: true})
                                    }} text={'Dodaj wpis'}/>
                                </div>
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                {
                                    Boolean(this.state.obsadaDoZamiany) ?
                                        <ObsadaListaZamianaForm obsadaDoZamiany={this.state.obsadaDoZamiany}
                                                                handleClickAnuluj={this.zamknijFormularz}
                                                                handleEdytujZasobyObsady={this.onClickZapiszZamiane}
                                        />
                                        :
                                        <ObsadaListaForm handleClickAnuluj={this.zamknijFormularz}
                                                         trasy={this.props.trasy}
                                                         kierowcy={this.props.kierowcy}
                                                         pojazdy={this.props.pojazdy}
                                                         handleClickZapisz={this.onClickZapisz}
                                                         duplikowanaObsada={this.state.duplikowanaObsada}
                                        />
                                }
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <ObsadaListaTable data={this.state.rekordyFilter}
                                              wlaczSzukanie={true}
                                              handleChange={this.onClickEdytuj}
                                              handleOdwolaj={this.onClickOdwolaj}
                                              handleEdytujZasoby={this.onClickEdytujZasoby}
                                              handleOdwolajPrzywrocBis={(obj,czyOdwolac)=>this.onClickOdwolajPrzywrocBis(obj,czyOdwolac)}
                                              trasy={this.props.trasy}
                                              kierowcy={this.props.kierowcy}
                                              pojazdy={this.props.pojazdy}
                                              duplikuj={this.onClickDuplikuj}
                                              handleZmienStatus={this.onClickZmienStatus}
                                              history={this.props.history}
                                              kolorRezerwacja={this.state.kolorRezerwacja}
                                              kolorSprzedany={this.state.kolorSprzedany}
                                              kolorSkasowany={this.state.kolorSkasowany}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaLista/ObsadaListaContainer.js